module.exports = __webpack_public_path__ + "img/emoji_96.3e278dd8.png";